import { connect } from 'react-redux';
import DocumentMenuBar from '../presentation/view_document_page/DocumentMenuBar';
import { setFavoriteDocument, setSubscribeDocument, sendDocumentEmail, lockDocument } from '../../actions/DocumentAction'
import { isBrowser } from 'react-device-detect';
import { removeProfileValues } from '../../actions/ProfileAction';

const mapStateToProps = (state) => {
    return { state, documents: state.documents.filteredlist, metadata: state.documents.metadata, url: state.documents.url, strings: state.i18.strings };
}

const mapDispatchToProps = dispatch => {
    return {
        favoriteDoc: (metadata) => { dispatch(setFavoriteDocument(metadata['id'].value)); },
        removeProfileValues: (...values) => { dispatch(removeProfileValues(values)); },
        subscribeDoc: (metadata) => { dispatch(setSubscribeDocument(metadata['id'].value)); },
        sendDocEmail: (metadata, to, url) => {
            dispatch(sendDocumentEmail(metadata, to, url));
        },
    }
}

const DocumentMenuBarView = isBrowser ?
    connect(mapStateToProps, mapDispatchToProps)(DocumentMenuBar) :
    connect(mapStateToProps, mapDispatchToProps)(DocumentMenuBar)

export default DocumentMenuBarView;